import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './static/build.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'

// import { Quill, quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// import scroll from 'vue-seamless-scroll'

import axios from "axios"
axios.defaults.baseURL = '/api'  //关键代码

Vue.config.productionTip = false
Vue.prototype.$axios = axios;

// Vue.use(scroll)
Vue.use(ElementUI);

router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
